import {StreamDescription as StreamDescriptionInterface} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/category_page/v1/stream/stream.types';
import {
  ProductTileAdditionalStreamTitle,
  ProductTileEndOfStream,
  Slot,
} from '@aboutyou/ui-components';
import React, {FC} from 'react';
import styled from 'styled-components';
import {NonProductTileSpacingAdjustment} from '../helpers';

type Props = {
  tile: StreamDescriptionInterface;
  gridColumns: number | undefined;
  streamPosition: number;
  className?: string;
};

export const StreamDescription: FC<Props> = ({
  tile,
  gridColumns,
  streamPosition,
  className,
}) => {
  if (tile.type?.$case === 'endOfStreamDescription') {
    return (
      <StyledSlot
        columns={gridColumns}
        position={streamPosition}
        className={className}
        Comp="li"
      >
        <ProductTileEndOfStream
          endOfStreamDescription={tile.type.endOfStreamDescription}
          Comp="div"
        />
      </StyledSlot>
    );
  }

  if (tile.type?.$case === 'additionalStreamTitle') {
    return (
      <StyledSlot
        columns={gridColumns}
        position={streamPosition}
        className={className}
        Comp="li"
      >
        <ProductTileAdditionalStreamTitle
          additionalStreamTitle={tile.type.additionalStreamTitle}
          gridColumns={gridColumns}
        />
      </StyledSlot>
    );
  }

  return null;
};

const StyledSlot = styled(Slot)`
  ${NonProductTileSpacingAdjustment}
`;
